import React, { ChangeEvent, useContext, useState } from 'react';
import { SearchField } from '../../../../common';
import { AppContext } from '../../../../common/context/';
import { getChildNodes, getEmployeesIds } from '../../../../utils';
import { BaseConfirmModal } from '../../modals/BaseConfirmModal';
import { Props } from './selectEmployeesDatesProps';

const SelectEmployeesDates = ({
    isOpenModal,
    modalTitle,
    onClose,
    onSubmit,
    showControls,
    selectedEmplooyes,
}: Props) => {
    const { langResources } = useContext(AppContext);

    const [employee, setEmployee] = useState<number[]>(
        getEmployeesIds(getChildNodes(selectedEmplooyes))
    );
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const handlerSubmit = () => {
        onSubmit(employee, startDate, endDate);
    };

    const handlerChangeEmployee = (e: ChangeEvent<HTMLInputElement>) => {
        let nameOfEmployee = e.target.value;

        setSearchTerm(nameOfEmployee);

        if (nameOfEmployee === 'Todos') {
            let employeesIds = getEmployeesIds(getChildNodes(selectedEmplooyes));
            setEmployee(employeesIds);
        } else {
            const result = selectedEmplooyes.filter(
                (emp) => emp.text === nameOfEmployee
            );

            setEmployee(getEmployeesIds(result));
        }
    };

    const handlerClose = () => {
        onClose();
        setEmployee([]);
        setStartDate('');
        setEndDate('');
    };

    const handleResetSearchTerm = () => {
        setSearchTerm('');
    };

    return (
        <BaseConfirmModal
            isLoading={false}
            isOpen={isOpenModal}
            isShowControls={showControls}
            modalTitle={modalTitle}
            onClose={handlerClose}
            onSubmit={handlerSubmit}
            disableSubmit={
                startDate === '' || endDate === '' || employee.length === 0
            }
            textButton={langResources['reports.generate.report.button']}
        >
            <div className='modal-body'>
                <div className='row'>
                    <div className='d-flex flex-wrap flex-md-nowrap gap-2 w-100 mb-4 p-0'>
                        <div className='d-flex  w-100'>
                            <label
                                htmlFor='options'
                                className='form-label'
                                style={{ margin: 8 }}
                            >
                                {
                                    langResources[
                                        'filter.modal.select.employees.dates.starDate'
                                    ]
                                }
                            </label>
                            <input
                                type='date'
                                className='form-control text-dark'
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>

                        <div className='d-flex w-100'>
                            <label
                                htmlFor='options'
                                className='form-label'
                                style={{ margin: 8 }}
                            >
                                {
                                    langResources[
                                        'filter.modal.select.employees.dates.endDate'
                                    ]
                                }
                            </label>
                            <input
                                type='date'
                                className='form-control text-dark'
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className='mb-4 p-0'>
                        <SearchField
                            dataListId='datalistOptions'
                            selectItemId={handlerChangeEmployee}
                            inputPlaceholder={
                                langResources['create.workshift.Modal']['search']
                            }
                            labelTitle={
                                langResources[
                                    'filter.modal.select.employees.dates.select.employees'
                                ]
                            }
                            searchTerm={searchTerm}
                            handleResetSearchTerm={handleResetSearchTerm}
                        />
                        <datalist id='datalistOptions'>
                            <option value='Todos' defaultValue={'Todos'}></option>
                            {getChildNodes(selectedEmplooyes)?.map(
                                ({ id, text }) => (
                                    <option
                                        key={id}
                                        id={id.toString()}
                                        value={text}
                                    />
                                )
                            )}
                        </datalist>
                    </div>
                </div>
            </div>
        </BaseConfirmModal>
    );
};

export default SelectEmployeesDates;
